import { styled } from '../../../utils';

export const TableRowStyled = styled('div')`
  display: table-row;
`;
